import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-white" }

import Title from '../components/content/Title.vue';
import HeroText from '../components/content/HeroText.vue';
import Container from '../components/content/Container.vue';
import HelpOptions from '../components/content/HelpOptions.vue';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');

const contacts = brandService.getContacts();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Container, null, {
      default: _withCtx(() => [
        _createVNode(HeroText, {
          title: "This is awkward.",
          subtitle: "Unfortunately, we can't offer you internet at your address :("
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Container, null, {
        default: _withCtx(() => [
          _createVNode(Title, {
            class: "pt-20 mb-4",
            title: "How can we help?",
            centered: true,
            id: "contact"
          }),
          _createVNode(HelpOptions, {
            class: "pb-20",
            features: _unref(contacts)
          }, null, 8, ["features"])
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})